import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 4px 0;
`;

export const Title = styled.div`
  margin-right: auto;
`;

export const AlignTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ContentDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const HeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ProgressBarContainer = styled.div`
  background-color: #dbdbdb;
  border-radius: 5px;
  height: 8px;
`;

export const ProgressBarContent = styled.div`
  height: 100%;
  background-color: ${({ colofFillProgress }) => colofFillProgress};
  /* background-color: #d0af52; */
  width: 0;
  transition: width 0.5s;
  border-radius: 5px;
`;
